/**
 * Role helpers — single source of truth for role checks derived from the
 * authenticated user object. Hides role-string normalisation (case + null
 * safety) so callers never re-implement the "admin" comparison.
 */
export function isAdmin(user) {
  return (user?.role || '').toLowerCase() === 'admin';
}

/**
 * Platform super-admin check. Backend sends `isSuperAdmin` as a real boolean
 * on /auth/me — coerce safely; do not string-compare.
 */
export function isSuperAdmin(user) {
  return !!user?.isSuperAdmin;
}
